import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Autocomplete from "../Autocomplete/Autocomplete";

import Button from "../CustomButtons/Button";
import { Close } from "@mui/icons-material";
import { MenuItem, Select } from "@mui/material";

/**
 * @props {bool} showHeaders
 * @props {String} headerText text voor de header
 * @props {String} dropdownText text voor de dropdown placeholder
 * @props {String} selectedText Kopje boven de geselecteerde producten
 * @props {Array} selectedItems Een array van geselecteerde items
 * @props {Function} onChange functie als er een item gezelecteerd wordt
 * @props {Array} items array van items waar de gebruiker keuzen uit heeft
 * @props {bool} singleSelect of dat een item als die geselecteerd is nog een keer mag voorkomen
 * @returns {TagList}
 *
 */

function TagList({ ...props }) {
  let classes = {};

  const [selectedItems, setSelectedItems] = useState([...props.selectedItems]);
  const [hiddenInputValue, setHiddenInputValue] = useState(JSON.stringify([...props.selectedItems]));
  const items = [...props.items];

  useEffect(() => {
    setSelectedItems([...props.selectedItems]);
  }, [props.selectedItems]);

  const getSelectedItems = () => {
    return selectedItems.map((id, key) => {
      let selectedItemObj = items[items.findIndex((obj) => obj.id === id)];
      let removeItem = null;
      let setColor = "gray";
      if (!props.disabled) {
        removeItem = <Close onClick={() => handleRemove(selectedItemObj.id)} />;
        setColor = "primary";
      }
      return (
        //Fallback als er een id is ingeslopen die niet in de item lijst staat
        //Blijft nog wel in de array staan
        selectedItemObj !== undefined ? (
          <Button color={setColor} key={key} round>
            {selectedItemObj.label} {removeItem}
          </Button>
        ) : null
      );
    });
  };

  let suggestieObject = items.map((item, key) => {
    /**
     * Als een item maar 1 keer in de array mag voorkomen
     */
    if (props.singleSelect && selectedItems.includes(item.id)) {
      return null;
    }

    return (
      <MenuItem
        classes={{
          root: classes.selectMenuItem,
          selected: classes.selectMenuItemSelected,
        }}
        key={key}
        value={item.id}
      >
        {item.label}
      </MenuItem>
    );
  });

  let onSelectChange = (e) => {
    let newSelectedItems = [...selectedItems];

    newSelectedItems.push(e.target.value);

    if (props.onChange) {
      props.onChange(newSelectedItems);
    }

    if (props.hiddenFieldName) {
      setHiddenInputValue(JSON.stringify(newSelectedItems));
    }

    setSelectedItems(newSelectedItems);
  };

  let handleRemove = (id) => {
    let indexKey = selectedItems.indexOf(id);

    let newSelectedItems = [...selectedItems];

    newSelectedItems.splice(indexKey, 1);

    if (newSelectedItems.length > 0) {
      setHiddenInputValue(JSON.stringify(newSelectedItems));
    } else {
      setHiddenInputValue("");
    }

    if (props.onChange) {
      props.onChange(newSelectedItems);
    }

    setSelectedItems(newSelectedItems);
  };

  const renderInput = () => {
    /**
     * Disabled state
     */
    if (props.disabled) {
      return null;
    }

    /**
     * Autocomplete
     */
    if (props.autocomplete) {
      let extraFilters = false;

      /**
       * Als single select dan de al geslecterdeerde ids niet mee nemen in de search
       */
      if (props.singleSelect) {
        extraFilters = [
          {
            field: "id",
            operator: "notin",
            value: selectedItems,
          },
        ];
      }

      return (
        <Autocomplete
          async={{
            url: props.autocomplete.url,
            searchField: props.autocomplete.searchField,
            extraFilters: extraFilters,
          }}
          onClick={(item) => {
            if (item.value === null) {
              return;
            }

            let newSelectedItems = [...selectedItems];

            newSelectedItems.push(item.value);

            if (props.onChange) {
              props.onChange(newSelectedItems);
            }

            if (props.hiddenFieldName) {
              setHiddenInputValue(JSON.stringify(newSelectedItems));
            }

            setSelectedItems(newSelectedItems);

            if (props.onChange) {
              props.onChange(selectedItems);
            }
          }}
          placeHolderText={props.dropdownText}
          value={props.venue_id}
        />
      );
    }

    /**
     * Default normal select
     */
    return (
      <Select
        MenuProps={{
          className: classes.selectMenu,
        }}
        classes={{
          select: classes.select,
        }}
        displayEmpty
        onChange={onSelectChange}
        style={{ width: "100%" }}
        value={""}
      >
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
          }}
          disabled
          value={""}
        >
          {props.dropdownText}
        </MenuItem>
        {suggestieObject}
      </Select>
    );
  };

  return (
    <div>
      {props.hiddenFieldName ? <input name={props.hiddenFieldName} type={"hidden"} value={hiddenInputValue} /> : null}
      {props.showHeaders ? <h4>{props.headerText}</h4> : null}
      {renderInput()}
      <h6>{props.selectedText}</h6>
      {getSelectedItems()}
    </div>
  );
}

TagList.propTypes = {
  hiddenFieldName: PropTypes.string,
  showHeaders: PropTypes.bool,
  disabled: PropTypes.bool,
  headerText: PropTypes.object, //Text voor de header bijvoorbeeld selecteer een product
  dropdownText: PropTypes.oneOfType([PropTypes.object.isRequired, PropTypes.string.isRequired]), //Text voor de dropdown als er niks geselecteerd is.
  selectedText: PropTypes.object.isRequired, //Text voor de geselecteerde items
  onChange: PropTypes.func,
  selectedItems: PropTypes.array.isRequired,
  items: PropTypes.array.isRequired,
};

TagList.defaultProps = {
  showHeaders: true,
  disabled: false,
};

export default TagList;
